import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  complexHistoryOperationsFilter,
  complexHistoryOperationsFilterSelection,
  defaultComplexHistoryOperationsSelection,
} from 'app/dataProviders/filter-items'

import styles from '../../ComplexHistoryLink.module.scss'

type Props = {
  id: string
  pending: boolean
}

export const OperationFilter = ({ id, pending }: Props) => {
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип операции"
      header="Выберите тип операции"
      classNameLabel={styles.filterLabel}
      colorInverse
      disableAutoSelect
      defaultSelection={defaultComplexHistoryOperationsSelection}
      multiple={false}
      skipUpperSpace
      disabled={pending}
      dataBoxData={complexHistoryOperationsFilter}
      dataBoxSelection={complexHistoryOperationsFilterSelection}
    />
  )
}
